// GlidepathHeader.js
import React from 'react';
//import DOMPurify from 'dompurify';
//import './GlidepathHeader.css';

const GlidepathHeader = ({  GlidepathHeaderLabels = {} }) => (
  <div className="l-grid__row justify-content-center">
      <div className="l-grid__column-large-8 l-grid__column-medium-10 u-text-align-center">
          {/* eslint-disable-next-line */}
          <a name="PortfolioStructure">
              <h2 className="c-heading u-margin-bottom-m" tabIndex="0">
                  {GlidepathHeaderLabels?.headline}
              </h2>
          </a>
          <p className="c-copy u-margin-bottom-none" tabIndex="0">
              {GlidepathHeaderLabels?.subHeadline}
          </p>
      </div>
  </div>
)

export default GlidepathHeader;